"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PalletLabelQuantityType = void 0;
exports.PalletLabelQuantityType = {
    IMMUTABLE: "IMMUTABLE",
    MUTABLE: "MUTABLE",
    UNKNOWN: "UNKNOWN",
};
//# sourceMappingURL=pallet-label-quantity-type.js.map